import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Localization } from '@freelancer/localization';
import { Seo } from '@freelancer/seo';
import { Margin } from '@freelancer/ui/margin';
import * as Rx from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-home-page',
  template: `
    <fl-tracking-hotjar></fl-tracking-hotjar>
    <fl-bit *ngIf="showSeoNavbar" class="HomePage-secondaryNavBar">
      <fl-container class="HomePage-secondaryNavBarContainer">
        <app-home-page-seo-nav-bar></app-home-page-seo-nav-bar>
      </fl-container>
    </fl-bit>
    <app-home-page-hero></app-home-page-hero>

    <ng-container *ngIf="isRedesign$ | flAsync">
      <fl-bit
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomDesktop]="Margin.XXXXLARGE"
      >
        <fl-container class="HomePage-container HomePage-container--redesign">
          <app-companies-trust-logo
            [isRedesign]="true"
          ></app-companies-trust-logo>

          <fl-hr
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></fl-hr>

          <app-home-page-need-work-done
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
            [isRedesign]="true"
          ></app-home-page-need-work-done>

          <fl-hr
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></fl-hr>

          <app-home-page-benefits
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
            [isRedesign]="true"
          ></app-home-page-benefits>

          <fl-hr
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></fl-hr>

          <app-home-page-crowd-favorites
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></app-home-page-crowd-favorites>

          <fl-hr
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></fl-hr>

          <app-home-page-hire-categories-redesign
            [flMarginBottom]="Margin.XXLARGE"
            [flMarginBottomTablet]="Margin.XXXLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></app-home-page-hire-categories-redesign>
        </fl-container>
      </fl-bit>
      <fl-bit class="HomePage-apiEnterprise">
        <fl-container
          class="HomePage-container HomePage-container--redesign"
          flTrackingSection="HomePage"
        >
          <app-home-page-api-enterprise-v4></app-home-page-api-enterprise-v4>
        </fl-container>
      </fl-bit>
    </ng-container>

    <ng-container *ngIf="!(isRedesign$ | flAsync)">
      <fl-container class="HomePage-container">
        <app-companies-trust-logo></app-companies-trust-logo>
        <fl-hr
          [flMarginBottom]="Margin.XLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></fl-hr>

        <app-home-page-need-work-done
          [flMarginBottom]="Margin.XLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></app-home-page-need-work-done>

        <fl-hr
          [flMarginBottom]="Margin.XLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></fl-hr>

        <app-home-page-benefits
          [flMarginBottom]="Margin.XLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></app-home-page-benefits>
      </fl-container>

      <fl-bit
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomDesktop]="Margin.XXXXLARGE"
      >
        <fl-container class="HomePage-container HomePage-container--redesign">
          <fl-hr
            [flMarginBottom]="Margin.XLARGE"
            [flMarginBottomDesktop]="Margin.XXXXLARGE"
          ></fl-hr>
          <app-home-page-crowd-favorites></app-home-page-crowd-favorites>
        </fl-container>
      </fl-bit>

      <fl-container class="HomePage-container">
        <app-home-page-hire-categories
          [flMarginBottom]="Margin.XXLARGE"
          [flMarginBottomTablet]="Margin.XXXLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></app-home-page-hire-categories>

        <fl-hr
          [flMarginBottom]="Margin.XXLARGE"
          [flMarginBottomTablet]="Margin.XXXLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></fl-hr>

        <app-home-page-api-enterprise-v3
          [flMarginBottom]="Margin.XXXLARGE"
          [flMarginBottomDesktop]="Margin.XXXXLARGE"
        ></app-home-page-api-enterprise-v3>
      </fl-container>
    </ng-container>
  `,
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent implements OnInit {
  Margin = Margin;

  isRedesign$: Rx.Observable<boolean>;
  showSeoNavbar: boolean;

  @Input() description: string;
  @Input() title: string;

  constructor(
    private seo: Seo,
    private routes: ActivatedRoute,
    private localization: Localization,
  ) {}

  ngOnInit() {
    this.showSeoNavbar = this.localization.isEnglish();

    this.isRedesign$ = this.routes.queryParams.pipe(
      switchMap(params => {
        if (params.isRedesign === 't') {
          return Rx.of(true);
        }

        return Rx.of(false);
      }),
    );

    this.seo.setPageTags({
      title: this.title,
      description: this.description,
    });
  }
}
